export default __webpack_public_path__ + "static/media/logo.68992b6c.png";